import Vue from 'vue'
import Vuex from 'vuex'
import ResultPanel from '../../components/SpecialDeals/ResultPanel'

Vue.use(Vuex)

Vue.filter('formatPrice', (rawPrice) => {
  return rawPrice.toFixed(0).replace(/(\d)(?=(\d{3})+(?!\d))/g, '$1,')
})

Vue.component('result-panel', ResultPanel)

const apps = document.querySelectorAll('.vue-app')

Array.prototype.forEach.call(apps, el => new Vue({
  el,
  template: el.innerHTML
}))
